import React from 'react';
import { withGuidelineContext } from '../../contexts/GuidelineContext';

export default withGuidelineContext((props) => {
    return (
        <p dangerouslySetInnerHTML={{
            __html: props.guidelineContext.disclaimer
        }}/>
    )
})